import { IncomingMessage, ServerResponse } from 'http'
import { PageProvidersProps } from '../components/PageProviders'
import { ParsedUrlQuery } from 'querystring'
import { getInitialAppContent } from './getInitialAppContent'
import { getInitialSessionAndOptimizelyValues } from './getInitialSessionAndOptimizelyValues'
import { writeLinkHeader } from './writeLinkHeader'

export async function getPageProvidersProps(
  req: IncomingMessage | undefined,
  query: ParsedUrlQuery | undefined
): Promise<PageProvidersProps> {
  const [initialSessionAndOptimizelyValues, appContent] = await Promise.all([
    getInitialSessionAndOptimizelyValues(req, query),
    getInitialAppContent()
  ])

  return {
    ...initialSessionAndOptimizelyValues,
    appContent
  }
}

export function writePageResponseHeaders(
  req: IncomingMessage | undefined,
  res: ServerResponse | undefined
): void {
  if (req && res) {
    writeLinkHeader(req, res)
  }
}
